module.exports = __webpack_public_path__ + "static/media/5.6839ee08.jpg";